import { useContext } from 'react'

import { SchoolContext } from '../../../Providers/SchoolProvider'
import EntityList from './EntityList'

const InstitutionsList = ({ excluded = null, maxHeight, pinned = null, renderDetails = null, selected, onSelectedChange }) => {
  const { unmanagedInstitutions } = useContext(SchoolContext)

  return (
    <EntityList
      entities={unmanagedInstitutions}
      excluded={excluded}
      maxHeight={maxHeight}
      pinned={pinned}
      renderDetails={renderDetails}
      selected={selected}
      onSelectedChange={onSelectedChange}
    />
  )
}

export default InstitutionsList
